module.exports = __webpack_public_path__ + "static/img/image-3.659fe89.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new_feature/dashboard/recruiter/image-3.png
// module id = lICZ
// module chunks = 1